import type { RealtimeBackend, RealtimeCommand } from "./realtime.types";

let activeRealtimeBackend: RealtimeBackend | null = null;

export function setActiveRealtimeBackend(
  backend: RealtimeBackend | null,
): void {
  activeRealtimeBackend = backend;
}

export function getActiveRealtimeBackend(): RealtimeBackend | null {
  return activeRealtimeBackend;
}

export function hasActiveRealtimeBackend(): boolean {
  return activeRealtimeBackend !== null;
}

export function isActiveRealtimeBackendConnected(): boolean {
  if (!activeRealtimeBackend) {
    return false;
  }
  if (typeof activeRealtimeBackend.isConnected === "function") {
    return activeRealtimeBackend.isConnected();
  }
  return true;
}

export async function sendRealtimeCommand(
  command: RealtimeCommand,
): Promise<void> {
  if (!activeRealtimeBackend) {
    throw new Error("Realtime backend is not active");
  }
  await activeRealtimeBackend.send(command);
}
